export default {"src":"/_next/static/media/alert.738e988e.svg","height":84,"width":95,"blurWidth":0,"blurHeight":0};